type SalesRep = any;
type Distributor = { sales_reps?: SalesRep[]; name?: string; no_sales_reps_needed?: boolean };

function salesRepNames(distributor: Distributor, maxReps: number): string {
  const max = maxReps || 2;
  if (!distributor.sales_reps?.length) {
    if (distributor.no_sales_reps_needed) return `${distributor.name} Sales`;
    else return "";
  }

  let reps = distributor.sales_reps.slice(0, max);
  if (reps[0].name) {
    reps = reps.map(r => r.name);
  }

  if (distributor.sales_reps.length > max) {
    reps.push("+" + (distributor.sales_reps.length - max) + " more");
  }
  if (!reps[0].name && reps[0].id) {
    reps = ["Customer Service"];
  }
  return reps.join(", ");
}

export { salesRepNames };
